import DocumentTitle from 'react-document-title';
import { useQuery } from 'react-query';

import { Box } from '@hivebrite/design-system/Box';
import { Container } from '@hivebrite/design-system/Container';
import { Loader } from '@hivebrite/design-system/Loader';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import Membership from 'hb-react/shared/apps/Memberships/components/Membership';
import { useMembershipsPurchaseProcess } from 'hb-react/shared/apps/Memberships/containers/MembershipsIndex/hooks/useMembershipsPurchaseProcess';
import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';
import { generatePageTitle } from 'hb-react/shared/utils/generatePageTitle';
import { getPageTitleFromNetwork } from 'hb-react/shared/utils/getPageTitleFromNetwork';

export const SingleMembership = ({
  membershipId,
  purchaseStrategyType,
  readOnly,
}) => {
  const { currentNetwork } = useDefaultAppContexts();
  const { topicId } = useTopicContext();

  const { onSelect, onPurchase, onLogin, isDisabled } =
    useMembershipsPurchaseProcess(purchaseStrategyType);

  const { currentUser } = useDefaultAppContexts();
  const programme = purchaseStrategyType;

  const { data: membership, isLoading } = useQuery(
    ['membership', membershipId],
    () => {
      let route = '';

      if (topicId) {
        route = Routes.topics_topic_memberships_v2_path(topicId, membershipId);
      } else {
        route = Routes.users_memberships_v2_path(membershipId);
      }

      return axios.get(route).then((response) => response.data);
    },
  );

  if (isLoading || !membership) {
    return <Loader />;
  }

  return (
    <>
      <DocumentTitle
        title={generatePageTitle({
          title: membership.title,
          networkName: getPageTitleFromNetwork(currentNetwork),
        })}
      />
      <Container pb={50} pt={9}>
        <Grid width="100%">
          <Row>
            <Col
              width={({ numCols }) => ({
                _: 1,
                xl: 10 / numCols,
              })}
              offset={({ numCols }) => ({
                _: 0,
                xl: 1 / numCols,
              })}
            >
              <Box
                key={membership.id}
                mb={6}
                data-testid={`membership-${membership.id}`}
              >
                <Membership
                  {...membership}
                  onSelect={onSelect}
                  onPurchase={onPurchase}
                  onLogin={onLogin}
                  programme={programme}
                  disabled={isDisabled?.(membership)}
                  readOnly={readOnly}
                  isPublic={!currentUser}
                />
              </Box>
            </Col>
          </Row>
        </Grid>
      </Container>
    </>
  );
};
